import { gql } from '@/shared/graphql/generated/reporting';

export const getAllSwapsQuery = gql(/* GraphQL */ `
  query GetAllSwaps(
    $first: Int
    $offset: Int
    $destinationOrRefundAddress: String
    $swapRequestNativeId: BigInt
    $mainBrokerAccountSs58Id: String
    $affiliateBrokerAccountSs58Id: String
    $asset: ChainflipAsset
    $isOnChain: Boolean
    $isLiquidation: Boolean
    $lpRefundAddress: String
    $alias: String
    $includeInternals: Boolean = false
  ) {
    allSwapRequests(
      orderBy: [IS_IN_PROGRESS_DESC, SWAP_REQUEST_NATIVE_ID_DESC]
      offset: $offset
      first: $first
      condition: {
        isOnChain: $isOnChain
        isLiquidation: $isLiquidation
        destinationAddress: $lpRefundAddress
        refundAddress: $lpRefundAddress
      }
      filter: {
        or: [
          { destinationAddress: { includesInsensitive: $destinationOrRefundAddress } }
          { refundAddress: { includesInsensitive: $destinationOrRefundAddress } }
          { swapRequestNativeId: { equalTo: $swapRequestNativeId } }
          { mainBrokerAccountSs58Id: { equalTo: $mainBrokerAccountSs58Id } }
          { affiliateBroker1AccountSs58Id: { equalTo: $affiliateBrokerAccountSs58Id } }
          { affiliateBroker2AccountSs58Id: { equalTo: $affiliateBrokerAccountSs58Id } }
          { affiliateBroker3AccountSs58Id: { equalTo: $affiliateBrokerAccountSs58Id } }
          { affiliateBroker4AccountSs58Id: { equalTo: $affiliateBrokerAccountSs58Id } }
          { affiliateBroker5AccountSs58Id: { equalTo: $affiliateBrokerAccountSs58Id } }
          { sourceAsset: { equalTo: $asset } }
          { destAsset: { equalTo: $asset } }
          { accountByMainBrokerAccountSs58Id: { alias: { includesInsensitive: $alias } } }
        ]
        and: [
          {
            or: [{ isInternal: { equalTo: false } }, { isInternal: { equalTo: $includeInternals } }]
          }
        ]
      }
    ) {
      pageInfo {
        hasPreviousPage
        startCursor
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...SwapRequestOverview
        }
      }
      totalCount
    }
  }

  fragment SwapRequestOverview on SwapRequest {
    id
    swapRequestNativeId
    sourceAsset
    destAsset
    baseAssetLeg1
    baseAssetLeg2
    totalInputAmount
    totalInputValueUsd
    ingressAmount
    ingressValueUsd
    egressAmount
    egressValueUsd
    inputAmount
    inputValueUsd
    intermediateAmount
    intermediateValueUsd
    outputAmount
    outputValueUsd
    refundAmount
    refundValueUsd
    networkFeeValueUsd
    totalChunks
    executedChunks
    isDca
    isBoosted
    isLiquidation
    isInternal
    isCcm
    isVaultSwap
    isOnChain
    completedBlockId
    completedBlockTimestamp
    completedBlockDate
    mainBrokerAccountSs58Id
    mainBrokerFeeValueUsd
    affiliateBroker1AccountSs58Id
    affiliateBroker1FeeValueUsd
    affiliateBroker2AccountSs58Id
    affiliateBroker2FeeValueUsd
    affiliateBroker3AccountSs58Id
    affiliateBroker3FeeValueUsd
    affiliateBroker4AccountSs58Id
    affiliateBroker4FeeValueUsd
    affiliateBroker5AccountSs58Id
    affiliateBroker5FeeValueUsd
    completedInSeconds
    startedBlockDate
    startedBlockId
    startedBlockTimestamp
    destinationAddress
    outputAndIntermediateValueUsd
    refundAddress
    status
    isInProgress
    oraclePriceDeltaBps
    oraclePriceDeltaExFeesBps
    liquidationType
    broker: accountByMainBrokerAccountSs58Id {
      alias
    }
  }
`);

export const getAllFilteredSwapsQuery = gql(/* GraphQL */ `
  query GetAllFilteredSwaps(
    $first: Int
    $offset: Int
    $after: Cursor
    $startDate: Date!
    $endDate: Date!
    $status: [SwapStatus!]
    $assetsTo: [ChainflipAsset!]
    $assetsFrom: [ChainflipAsset!]
    $destinationAddress: String
    $refundAddress: String
    $brokers: [String!]
    $isBoosted: Boolean
    $isDca: Boolean
    $isCcm: Boolean
    $isVaultSwap: Boolean
    $isOnChain: Boolean
    $isLiquidation: Boolean
    $minValueUsd: BigFloat
    $maxValueUsd: BigFloat
  ) {
    allSwapRequests(
      orderBy: [IS_IN_PROGRESS_DESC, SWAP_REQUEST_NATIVE_ID_DESC]
      offset: $offset
      after: $after
      first: $first
      condition: {
        isBoosted: $isBoosted
        isDca: $isDca
        isCcm: $isCcm
        isVaultSwap: $isVaultSwap
        isOnChain: $isOnChain
        isLiquidation: $isLiquidation
      }
      filter: {
        startedBlockDate: { greaterThanOrEqualTo: $startDate, lessThanOrEqualTo: $endDate }
        status: { in: $status }
        sourceAsset: { in: $assetsFrom }
        or: [
          { mainBrokerAccountSs58Id: { inInsensitive: $brokers } }
          { affiliateBroker1AccountSs58Id: { inInsensitive: $brokers } }
        ]
        destAsset: { in: $assetsTo }
        isInternal: { equalTo: false }
        destinationAddress: { equalTo: $destinationAddress }
        refundAddress: { equalTo: $refundAddress }
        totalInputValueUsd: { greaterThanOrEqualTo: $minValueUsd, lessThanOrEqualTo: $maxValueUsd }
      }
    ) {
      pageInfo {
        hasPreviousPage
        startCursor
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...SwapRequestOverview
        }
      }
      totalCount
    }
  }
`);

export const getSpecificSwapRequestsQuery = gql(/* GraphQL */ `
  query GetSpecificSwapRequests($swapRequestIds: [BigInt!]!) {
    allSwapRequests(filter: { swapRequestNativeId: { in: $swapRequestIds } }) {
      nodes {
        ...SwapRequestOverview
      }
    }
  }
`);
